<div class="skeleton-container" [ngClass]="'skeleton-container-' + config().type">
  @for (item of items(); track $index) {
    <div 
      [ngClass]="getSkeletonClass()"
      [ngStyle]="getSkeletonStyle()"
      [attr.aria-label]="'Carregando conteúdo'"
      [attr.role]="'status'">
    </div>
  }
</div>
